module.exports = __webpack_public_path__ + "static/media/logo-left.2508e010.psd";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-left.psd
// module id = 139
// module chunks = 0